if (!Enum) {
    var Enum = {};
}

Enum.HOSPITAL_SHIFT_TYPE = {
    NIGHTLY: 'NIGHTLY',
    DAILY: 'DAILY',
    WEEKEND_DAILY: 'WEEKEND_DAILY',
    WEEKEND_NIGHTLY: 'WEEKEND_NIGHTLY',
    ANAESTHESIOLOGICAL: 'ANAESTHESIOLOGICAL'
};

Object.freeze(Enum.ALLERGY_TYPE);